module.exports = "/_next/static/images/personal_trainer_illustration-a0309d081572f285b5627fea056d6264.svg";